import { css } from 'styled-components'

/**
 * Extend this element to the edge of the current container, and retain the
 * same lines for content placement.
 */
export const fullWidth = css`
	padding-left: 32px;
	margin-left: -32px;
	padding-right: 32px;
	margin-right: -32px;
`

/**
 * Extend this element to the edge of the current container, but do not add any
 * padding to align with other content.
 */
export const fullWidthContent = css`
	margin-left: -32px;
	margin-right: -32px;
`
